import {useMemo} from 'react';

import {useDateTime} from 'src/hooks/date-time/useDateTime';

import type {NotificationSearchCriteria} from 'src/openapi/admin/models/NotificationSearchCriteria';

export const useDefaultFilters = () => {
    const {getTodayString} = useDateTime();
    return useMemo<NotificationSearchCriteria>(() => ({
        startDate: getTodayString(),
    }), [getTodayString]);
};
